module.exports = __webpack_public_path__ + "media/theme/blog__border-12-3adbf999.png";